<template>
    <span>
        <b-card :no-body="true">
            <b-card-body>
                <div v-if="titulo" class="text-uppercase font-weight-bold text-center h4 border-bottom border-dark">
                    {{ titulo }}
                </div>
                <div v-if="dados">
                    <b-col v-for="chave in nomesDadosLista" :key="chave">
                        <b-row class="border-bottom"
                            style="
                                align-items: center;
                                display: flex;
                                padding-top: 5px;
                                padding-bottom: 5px;"
                        >
                            <b-col
                                style="margin-bottom: 0px;"
                                sm="12"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                class="p-0"
                                >
                                    <span 
                                        :title="obterDescricao(chave)"
                                    >
                                        <span 
                                            class="text-primary"
                                        >
                                            <i class="fa fa-info-circle fa-lg"></i>
                                        </span>
                                        <span
                                            :class="{ 
                                                'p-0': $mq != 'sm' && $mq != 'md',
                                                'h5': $mq != 'sm' && $mq != 'md'
                                            }"
                                        >
                                            {{ obterNomeDado(chave) }}
                                        </span>
                                    </span>
                            </b-col>
                            <b-col
                                sm="12"
                                :md="mddiff"
                                :lg="lgdiff"
                                :xl="xldiff"
                                :class="{ 
                                    'p-0': $mq != 'sm' && $mq != 'md', 
                                    'h5': $mq != 'sm' && $mq != 'md',
                                }"
                                style="
                                    margin-bottom: 0px;
                                    align-items: end;
                                "
                            >   
                                <span v-if="obterTipoDado(chave) == null">
                                    <strong >
                                        {{ obterDado(chave) }}
                                    </strong>
                                </span>
                                <span v-if="obterTipoDado(chave) == 'qtd'">
                                    <strong v-if="obterDado(chave) != 0">
                                        {{ obterDado(chave) }}
                                    </strong>
                                    <strong v-if="obterDado(chave) == 0">
                                        Não houve ação
                                    </strong>
                                </span>
                                <span v-if="obterTipoDado(chave) == 'money'">
                                    <strong>
                                        {{ obterDado(chave) | currency }}
                                    </strong>
                                </span>
                                <span v-if="obterTipoDado(chave) == 'date'">
                                    <strong>
                                        {{ $moment(obterDado(chave)).format('DD/MM/YYYY') }}
                                    </strong>
                                </span>
                                <span v-if="obterTipoDado(chave) == 'media'">
                                    <strong v-if="obterDado(chave) != null">
                                        {{ obterDado(chave) | currency2 }} dia(s)
                                    </strong>
                                    <strong v-if="obterDado(chave) == null">
                                        Não houve ação 
                                    </strong>
                                </span>
                                <span v-if="obterTipoDado(chave) == 'hide'"></span>
                            </b-col>
                            <b-col
                                style="margin-bottom: 0px;"
                                :sm="1"
                                :md="1"
                                :lg="1"
                                :xl="1"
                                class="p-0"
                            >
                                <quadro-dados-detalhamento
                                    :chave="chave"
                                    :dados="dados"
                                >
                                </quadro-dados-detalhamento>
                            </b-col>
                        </b-row>
                    </b-col>
                </div>
                <div v-if="!dados" class="text-uppercase text-center h4 mb-0 pt-3">
                    Não existem dados referentes a essa competência
                </div>
            </b-card-body>
        </b-card>
    </span>
</template>

<script>
import QuadroDadosDetalhamento from './QuadroDadosDetalhamento.vue';

export default {
    props: {
        dados: {
            type: Object,
            default: () => null
        },
        titulo: {
            type: String,
            default: () => null
        },
        nomesDados: {
            type: Object,
            default: () => ({}) 
        },
        tiposDados: {
            type: Object,
            default: () => ({}) 
        },
        descricoes: {
            type: Object,
            default: () => ({}) 
        },
        preencherVazio: {
            type: Boolean,
            default: () => true
        },
        md: {
            type: Number,
            default: () => 7
        },
        lg: {
            type: Number,
            default: () => 7
        },
        xl: {
            type: Number,
            default: () => 7
        }
    },

    methods: {
        obterNomeDado(chave) {
            if (this.nomesDadosLista.includes(chave)) {
                return this.nomesDados[chave]
            }
            return chave
        },

        obterTipoDado(chave) {
            return this.tiposDados[chave]       
        },

        obterDado(chave) {
            return this.dados[chave]
        },

        obterDescricao(chave) {
            return this.descricoes[chave]
        }
    },

    computed: {
        chaveLista() {
            return Object.keys(this.dados)
        },

        nomesDadosLista() {
            return Object.keys(this.nomesDados)
        },

        mddiff() {
            return 12 - this.md - 1
        },

        lgdiff() {
            return 12 - this.lg - 1
        },

        xldiff() {
            return 12 - this.xl - 1
        }
    },

    components: {
        QuadroDadosDetalhamento
    }
}
</script>